import React, { useState } from 'react';
import {
  ConnectToQBO as connectSVG,
  ConnectToQBOHover as connectHoverSVG,
} from '../../assets/intuit';
import style from './QuickBooksButton.module.scss';

const QuickBooksButton = ({ ...rest }) => {
  const [hovering, setHovering] = useState(false);
  return (
    <button
      type="button"
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={style.connectToQBO}
      {...rest}
    >
      <img src={hovering ? connectHoverSVG : connectSVG} alt="Connect to QuickBooks Online" />
    </button>
  );
};

export default QuickBooksButton;
